import { Repository } from "src/firebase/firestore/repository";
import { Booking, BookingCancellationEntity } from "../types/booking.entity";

class BookingRepository extends Repository<Booking> {
  private readonly fallbackCollection = "bookings";
  constructor() {
    super("booking");
  }

  async findById(id: string): Promise<Booking | null> {
    const primary = await super.findById(id);
    if (primary) return primary;
    // Fallback to legacy plural collection if primary is empty
    try {
      const alt = await (this as any).findByCollectionAndId(this.fallbackCollection, id);
      return alt as Booking;
    } catch {
      return null;
    }
  }

  async find(args: any): Promise<(Booking & { id: string })[]> {
    const primary = await super.find(args);
    if (primary && primary.length > 0) return primary as any;
    const legacyRepo = new Repository<Booking>(this.fallbackCollection);
    return (await legacyRepo.find(args)) as any;
  }

  async count(where?: any): Promise<number> {
    const primary = await super.count(where);
    if (primary > 0) return primary;
    const legacyRepo = new Repository<Booking>(this.fallbackCollection);
    return await legacyRepo.count(where);
  }
}

export const bookingRepository = new BookingRepository();
